module.exports = __webpack_public_path__ + "img/kimchi-guide.49175341.png";